import { render, staticRenderFns } from "./OutstandingPartListSideMenu.vue?vue&type=template&id=0afa85d6&scoped=true"
import script from "./OutstandingPartListSideMenu.vue?vue&type=script&lang=js"
export * from "./OutstandingPartListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OutstandingPartListSideMenu.vue?vue&type=style&index=0&id=0afa85d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa85d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afa85d6')) {
      api.createRecord('0afa85d6', component.options)
    } else {
      api.reload('0afa85d6', component.options)
    }
    module.hot.accept("./OutstandingPartListSideMenu.vue?vue&type=template&id=0afa85d6&scoped=true", function () {
      api.rerender('0afa85d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/outstandingpart/OutstandingPartListSideMenu.vue"
export default component.exports